import variablePlan from "./variablePlan.component";
import variablePlanUrls from "./variablePlan.urls";
import VariablePlanTransforms from "./variablePlan.transforms";

const variablePlanModule = angular
  .module("app.components.variablePlan", [])
  .component("variablePlanPage", variablePlan)
  .service("VariablePlanTransforms", VariablePlanTransforms)
  .config(variablePlanUrls);

export default variablePlanModule;



// WEBPACK FOOTER //
// ./src/pages/variablePlan/variablePlan.module.js